export function DrawDeliveryModel () {
    this.campaignImgUrl = '';
    this.campaignName = '';
    this.campaignExpiredTimestamp = '';
    this.privilegeMessage = '';
    this.privilegeMessageFormat = '';
    this.type = '';
    this.delivered = '';

    this.setModelFromDataModel = (campaign) => {
        this.campaignImgUrl = campaign.fullImageUrl || '';
        this.campaignName = campaign.name || '';
        this.campaignExpiredTimestamp = campaign.expireDate || '';
        this.privilegeMessage = campaign.privilegeMessage || '';
        this.privilegeMessageFormat = campaign.privilegeMessageFormat || '';
        this.type = campaign.type || '';
        this.delivered = campaign.delivered;
    };
}
